import clsx from 'clsx';

import { Modal as ModalCore, IModalProps as IModalPropsCore } from '../core/modal';
import { Icon } from 'components/icon/icon';

import CrossIcon from 'public/assets/icons/cross.svg';
import styles from './modal.module.scss';

export interface IModalProps extends IModalPropsCore {
	isHidden?: boolean;
}

const Modal = (props: IModalProps): React.JSX.Element => {
	return (
		<ModalCore
			propStyles={styles}
			closeIcon={<Icon customIcon={<CrossIcon />} size="20px" />}
			bodyPadding={[24, 40]}
			className={clsx(props.className, props.isHidden && styles.hide)}
			{...props}
		>
			{props.children}
		</ModalCore>
	);
};

export { Modal };
